import triggerPropertyChangeAction from './triggerPropertyChangeAction';
import {
	HOIST_APPEND_TO_PROP,
	HOIST_ATTR,
	NOW_HOIST_APPEND_TO_PROP,
	NOW_HOIST_PREPEND_TO_PROP,
	NOW_HOIST_PROP,
	PROPERTY_SELECTOR_SIGIL
} from '../constants';
import {HOIST_CHANGED, HOIST_PARENT_CHANGED, PROPERTY_DEFS, RENDER, VARIABLES} from '../symbols';
import log from '../log';
import {isPropToSkipRender} from './isPropToSkipRender';

export default function triggerComponentUpdates(
	componentRegistry,
	affected,
	propertyDetails,
	interactionId,
	label,
	options = {}
) {
	const {value} = propertyDetails;
	const renderList = [];
	for (const id in affected) {
		const [elementId, propName] = id.split(PROPERTY_SELECTOR_SIGIL);
		const el = componentRegistry[elementId];
		renderList.push({
			elementId,
			tagName: el?.tagName,
			propName,
			propDef: el?.[VARIABLES]?.[PROPERTY_DEFS]?.[propName]
		});

		if (el && propName) {
			triggerPropertyChangeAction(
				el,
				propertyDetails,
				{propName, path: affected[id]},
				interactionId,
				options.activeSpan
			);

			if (propName === NOW_HOIST_PROP || propName === HOIST_ATTR) el[HOIST_CHANGED](value);

			if (
				propName === HOIST_APPEND_TO_PROP ||
				propName === NOW_HOIST_APPEND_TO_PROP ||
				propName === NOW_HOIST_PREPEND_TO_PROP
			)
				el[HOIST_PARENT_CHANGED](propName);
		}
	}

	for (let i = 0; i < renderList.length; i++) {
		const {elementId, tagName, propName, propDef} = renderList[i];
		if (componentRegistry[elementId]) {
			if (!isPropToSkipRender(tagName, propName, propDef))
				componentRegistry[elementId][RENDER](interactionId, label, {
					propName,
					value,
					activeSpan: options.activeSpan
				});
		} else {
			log(
				`Component with id "${elementId}" could not be re-rendered from a change in property "${propName}" because the component is disconnected or not known.`,
				{
					componentId: elementId,
					origin: 'triggerComponentUpdates'
				}
			);
		}
	}
}
